import { render, staticRenderFns } from "./ReportColumnTotal.vue?vue&type=template&id=32302a82&"
import script from "./ReportColumnTotal.vue?vue&type=script&lang=js&"
export * from "./ReportColumnTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32302a82')) {
      api.createRecord('32302a82', component.options)
    } else {
      api.reload('32302a82', component.options)
    }
    module.hot.accept("./ReportColumnTotal.vue?vue&type=template&id=32302a82&", function () {
      api.rerender('32302a82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportTable/ReportColumnTotal.vue"
export default component.exports